import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import CultureBonus from '@/roc/effects/CultureBonus/CultureBonus';
import CultureAmount from '@/roc/effects/CultureBonus/CultureAmount';
import CultureRange from '@/roc/effects/CultureBonus/CultureRange';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const Woodhenge = {
  id: '82',
  name: 'Woodhenge',
  width: 3,
  height: 3,
  type: BuildingType.COLLECTABLE,
  era: 'stoneAge',
  icon: 'Woodhenge',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Woodhenge',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new CultureBonus(
      CultureAmount.asPerLevel([
        200, 250, 300, 350, 400, 450, 500, 550, 600, 650,
        700, 750, 800, 850, 900, 950, 1000, 1050, 1100, 1150,
        1200, 1250, 1300, 1350, 1400, 1450, 1500, 1550, 1600, 1650,
        1700, 1750, 1800, 1850, 1900, 1950, 2000, 2050, 2100, 2150
      ]),
      CultureRange.asFlat(2),
    ),
    new ProductionQueue(
      ProductionWorkforce.asCallbackWithLevel(
        (level) => {
          if (level === 1) {
            return 1;
          }
          if (level <= 5) {
            return 2;
          }
          if (level <= 9) {
            return 3;
          }
          if (level <= 19) {
            return 4;
          }
          if (level <= 29) {
            return 5;
          }
          if (level <= 39) {
            return 6;
          }
          return 7;
        }
      ),
      [
        ProductionCost.asCallbackWithLevel(
          (level) => {
            return 3000 * level;
          }
        ).withCurrency(ProductionCurrency.FOOD),
      ],
      ProductionDuration.asFlat(4 * 60 * 60),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          return 100 + (level - 1) * 25;
        }
      ).withOutput(ProductionOutputType.ALL_PREVIOUS_ERA_GOODS),
    ),
  ]),
};

export default Woodhenge;
